var React = require('react');

function Circle (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"cx":"7.2","cy":"7","r":"4","fill":"#fff","key":0}),React.createElement("path",{"d":"M7.2 4c1.7 0 3 1.3 3 3s-1.3 3-3 3-3-1.3-3-3 1.3-3 3-3m0-2c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.3-5-5-5z","fill":"#444","key":1})]);
}

Circle.defaultProps = {"viewBox":"0 0 14 14"};

module.exports = Circle;

Circle.default = Circle;
